import { render, staticRenderFns } from "./RecordZonesPanel.vue?vue&type=template&id=1f528ec2"
import script from "./RecordZonesPanel.vue?vue&type=script&lang=js"
export * from "./RecordZonesPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports